<div class="toast-booking">
  <p-toast position="top-right" [key]="'save'">
    <ng-template let-message pTemplate="message">
      <div class="flex flex-col" style="flex: 1">
        <div class="flex gap-3">
          <i
            class="font-semibold"
            [ngClass]="[
              message.severity === 'success' ? 'sctr-icon-check-circle' : 'sctr-icon-alert-circle'
            ]"
            style="font-size: 20px"
          ></i>
          <p class="pb-2 text-md font-medium text-black">
            {{ message.detail }}
          </p>
        </div>
        <div class="pl-[20px]">
          <button
            class="px-[12px] py-[4px] hover:rounded-lg hover:border-solid hover:bg-[#EFF8FF]"
            (click)="openDialog()"
          >
            <p class="text-primary-600 text-md font-semibold">
              {{ 'toast_save_car.change' | translate }}
            </p>
          </button>
        </div>
      </div>
    </ng-template>
  </p-toast>
</div>
<div
  class="hot-deal-item flex h-full cursor-pointer flex-col rounded-lg border font-inter"
  (click)="viewDetails(item.id, item)"
>
  <div class="image-container h-[152px]">
    <img
      class="aspect-[3/2] h-[152px] w-full rounded-t-lg object-cover"
      src="{{ imageUrl }}"
      (error)="replaceWithDefaultImage($event)"
      alt="image"
      data-cy="url-img-hotel"
    />
    <div *ngIf="!is_with_driver_home">
      <span
        *ngIf="promotion"
        class="absolute !bottom-2 !left-2 rounded-[4px] bg-[#E62E05] !px-2 !py-1 text-center !text-sm font-medium text-white"
        >{{ promotion }}% {{ 'common.term.off' | translate }}</span
      >
      <ng-container
        *ngIf="
          item.badge_info && item.badge_info.badge_info?.id && item.badge_info.badge_info?.avatar
        "
      >
        <div class="absolute !left-2 !top-2 flex rounded-[4px] bg-[#10182866] p-1">
          <img
            class="aspect-square h-[24px] rounded-[4px] object-cover"
            [src]="(item.badge_info.badge_info.avatar | ImagePath : 'thumbnail') ?? ''"
            pTooltip="{{ item.badge_info?.badge_info?.name ?? '' }}"
            alt="{{ item.badge_info.badge_info?.name }}"
          />
        </div>
      </ng-container>
    </div>

    <div *ngIf="is_with_driver_home" class="absolute !left-2 !top-2 flex flex-row gap-1">
      <ng-container
        *ngIf="
          badgeMappingInfo &&
          badgeMappingInfo.badge_info_list &&
          badgeMappingInfo.badge_info_list.length > 0
        "
      >
        <div *ngFor="let badge of badgeMappingInfo.badge_info_list">
          <div class="rounded-[4px] bg-[#10182866] p-1">
            <img
              *ngIf="badge?.id && badge?.avatar"
              class="aspect-square h-[24px] rounded-[4px] object-cover"
              [src]="(badge.avatar | ImagePath : 'thumbnail') ?? ''"
              pTooltip="{{ badge?.name ?? '' }}"
              alt="{{ badge.name }}"
            />
          </div>
        </div>
      </ng-container>
      <span
        *ngIf="promotion"
        class="h-fit rounded-[4px] bg-[#E62E05] !px-2 !py-1 text-center !text-sm font-medium text-white"
        >-{{ promotion }}%</span
      >
    </div>

    <!-- <span
      *ngIf="!is_with_driver_home"
      class="quick-car-rental-bg absolute !left-2 !top-2 flex items-center gap-1 rounded-[4px] !px-2 !py-1 text-center !text-sm font-medium text-white"
    >
      <i class="sctr-icon-solid-zap text-sm text-amber-400"></i>
      {{ 'common.component.booking_details_content.quick_car_rental' | translate }}
    </span> -->
    <!-- <span
      *ngIf="is_with_driver_home"
      class="quick-car-rental-bg absolute !left-2 !top-2 flex items-center gap-1 rounded-[4px] !px-2 !py-1 text-center !text-sm font-medium text-white"
    >
      <i class="sctr-icon-solid-check-circle text-sm text-green-400"></i>
      {{ 'common.component.booking_details_content.quick_car_rental' | translate }}
    </span> -->
    <!-- <span
      class="bg-gradient-orange absolute left-2 top-2 rounded-lg p-[6px] text-center !text-sm font-semibold text-white"
      >{{with_without_driver==='with'?('page.ota.availability.with_driver'|translate):''}}
      {{with_without_driver==='without'?('page.ota.availability.without_driver'|translate):''}}
      {{with_without_driver==='with_without'?('page.ota.availability.with_without_driver'|translate):''}}</span -->

    <!-- <img *ngIf="!item.avatar" class="rounded-lg aspect-[16/9] w-full max-h-[118px] object-cover" src="{{baseImageId}}/{{ item.property_image_overview_id }}.webp" (error)="replaceWithDefaultImage($event)" alt=" " data-cy="url-img-hotel"> -->
    <button
      type="button"
      data-cy="btn-favorite"
      class="btn-favorite absolute right-2 top-2 rounded-lg p-[6px] text-center"
      (click)="handleBookmark($event, item)"
    >
      <span *ngIf="isBookmark; then favorite; else unfavorite"></span>
      <ng-template #favorite>
        <img class="!h-4 !w-4" src="assets/images/common-icon/bookmark-close.svg" alt="" />
      </ng-template>
      <ng-template #unfavorite>
        <img class="!h-4 !w-4" src="assets/images/common-icon/bookmark-open.svg" alt="" />
      </ng-template>
    </button>

    <div *ngIf="is_with_driver_home" class="z-1 absolute bottom-[-1px] left-0 flex">
      <div class="flex items-center gap-1 rounded-tr-[3px] bg-white pb-0.5 pl-2.5 pr-2 pt-1.5">
        <img [src]="getCarLogoBySeats(item?.seats)" class="h-[20px] w-[40px]" />
        <span class="text-sm font-semibold text-palette-gray-900"
          >{{ item?.seats }} {{ 'COMMON.SEATS' | translate }}</span
        >
      </div>
      <div class="tritangle-block"></div>
    </div>
  </div>
  <div class="flex h-full flex-col gap-2 rounded-lg bg-white !p-3">
    <div class="flex flex-col gap-2">
      <div
        #hotelName
        [tooltip]="item.vehicle_info?.car_model_name + ' ' + item.vehicle_info?.year_model"
        [isTruncated]="true"
        [position]="TooltipPosition.BELOW"
        class="line-clamp-1 h-[20px] text-[14px] font-semibold leading-5 text-palette-gray-900"
        data-cy="name-hotel"
      >
        {{
          !is_with_driver_home
            ? item.vehicle_info?.car_model_name + ' ' + item.vehicle_info?.year_model
            : item?.name
        }}
      </div>
      <div class="h-[44px]" *ngIf="!is_with_driver_home">
        <div
          *ngIf="with_without_driver === 'without' || with_without_driver === 'with_without'"
          class="flex h-full w-full flex-wrap gap-1 overflow-hidden"
        >
          <span
            *ngFor="let tag of tagList"
            class="flex h-min items-center justify-center rounded-full px-1.5 py-0.5 text-[12px] font-medium leading-4 {{
              tag.type
            }}"
          >
            {{ tag.name }}
          </span>
        </div>
      </div>
      <div class="relative flex items-center">
        <common-icon-text
          class="flex !w-full items-center overflow-hidden text-ellipsis"
          [icon]="'sctr-icon-marker-pin-01'"
          [iconStyle]="'text-base !leading-5 mr-1 opacity-70'"
          [text]="getAddress(item)"
          [textStyle]="
            'text-soctrip-small font-normal text-palette-gray-500 whitespace-nowrap text-ellipsis overflow-hidden'
          "
          [dataCyValue]="'address-hotel'"
        ></common-icon-text>
      </div>

      <!-- <div class="h-[20px]">
        <div
          *ngIf="with_without_driver === 'with' || with_without_driver === 'with_without'"
          class="flex h-full w-full flex-wrap gap-2 overflow-hidden"
        >
          <span class="flex items-center gap-1">
            <img src="assets/icons/transmission-icon.svg" />
            <span class="!text-sm text-palette-gray-500">{{
              (item?.is_automatic_transmission
                ? 'SEARCH_RESULT.car_list.automatic'
                : 'SEARCH_RESULT.car_list.manual'
              ) | translate
            }}</span>
          </span>
          <span class="flex items-center gap-1">
            <img src="assets/icons/seat.svg" />
            <span class="!text-sm text-palette-gray-500">{{
              'pluralization.Seat(s)' | translate : { count: item?.seats || 0 }
            }}</span>
          </span>
        </div>
      </div> -->

      <div class="flex h-6 items-center gap-2">
        <div class="icon-service col-span-1 flex h-4 items-center">
          <img src="assets/icons/like.svg" alt="MarkerPin" />
          <span
            class="text-soctrip-small ml-1 h-4 overflow-hidden text-ellipsis font-normal text-palette-gray-500"
            >{{ item.sum_review }}</span
          >
        </div>
        <span class="text-gray-700">•</span>
        <div class="icon-service col-span-1 flex h-4 items-center">
          <img src="assets/icons/trips.svg" alt="MarkerPin" />
          <span
            class="text-soctrip-small ml-1 h-[18px] overflow-hidden text-ellipsis font-normal text-palette-gray-500"
            >{{ item.trips }} {{ 'APP_OWNER_CONTACT_INFO.trips' | translate }}</span
          >
        </div>
      </div>
    </div>
    <div class="flex h-full flex-col justify-end">
      <ng-container
        *ngIf="
          item?.badge_info?.rank_info &&
          item?.badge_info?.rank_info?.reduce_amount &&
          !is_with_driver_home
        "
      >
        <div
          class="mb-1 mt-1 flex flex-row items-center gap-2 bg-gray-100 px-2 py-1"
          (click)="goToRankPage(item?.badge_info?.rank_info?.refer_link ?? '', $event)"
          pTooltip="{{ item?.badge_info?.rank_info?.name ?? '' }}"
        >
          <img
            class="aspect-square !h-6 !w-6 object-cover"
            [src]="(item?.badge_info?.rank_info?.avatar | ImagePath : 'thumbnail') ?? ''"
          />
          <div class="flex flex-col">
            <span class="text-xs font-normal text-gray-700">{{
              'common.term.discount_more' | translate
            }}</span>
            <span class="text-sm font-medium text-gray-900">
              <app-price-format
                [keepValue]="userCurrency === item?.currency"
                [price]="
                  badgeInfoService.getReduceAmountPrice(
                    item?.badge_info?.rank_info?.reduce_amount,
                    item?.badge_info?.rank_info?.reduce_amount / item?.price,
                    userCurrency,
                    item?.currency || 'USD',
                    item?.price || 0,
                    item?.price_canal || 0
                  )
                "
                [justifyContentClass]="'justify-start'"
              ></app-price-format>
            </span>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="
          badgeMappingInfo &&
          badgeMappingInfo?.rank_info &&
          badgeMappingInfo?.rank_info?.reduce_amount &&
          is_with_driver_home
        "
      >
        <div
          class="mb-1 mt-1 flex flex-row items-center gap-2 bg-gray-100 px-2 py-1"
          (click)="goToRankPage(badgeMappingInfo?.rank_info?.refer_link ?? '', $event)"
          pTooltip="{{ badgeMappingInfo?.rank_info?.name ?? '' }}"
        >
          <img
            class="aspect-square !h-6 !w-6 object-cover"
            [src]="(badgeMappingInfo?.rank_info?.avatar | ImagePath : 'thumbnail') ?? ''"
          />
          <div class="flex flex-col">
            <span class="text-xs font-normal text-gray-700">{{
              'common.term.discount_more' | translate
            }}</span>
            <span class="text-sm font-medium text-gray-900">
              <app-price-format
                [keepValue]="userCurrency === item?.currency"
                [price]="badgeMappingInfo?.rank_info?.reduce_amount"
                [justifyContentClass]="'justify-start'"
              ></app-price-format>
            </span>
          </div>
        </div>
      </ng-container>
      <div
        *ngIf="(originPrice || price) && !is_with_driver_home"
        class="flex min-h-12 w-full flex-col items-end justify-end"
      >
        <app-price-format
          *ngIf="originPrice > price"
          [keepValue]="userCurrency === item.currency"
          [price]="originPrice"
          [styleClass]="
            'text-palette-gray-500 text-[14px] font-normal whitespace-nowrap text-ellipsis overflow-hidden line-through truncate'
          "
        ></app-price-format>
        <div class="flex items-center">
          <app-price-format
            [keepValue]="userCurrency === item.currency"
            [price]="price"
            [styleClass]="'text-xl font-medium !leading-6 truncate text-palette-orange-dark-600'"
          ></app-price-format>
          <span class="overflow-hidden text-ellipsis text-md font-normal text-palette-gray-500"
            >/{{ 'COMMON.DAY' | translate }}</span
          >
        </div>
      </div>
      <div *ngIf="is_with_driver_home" class="flex h-[60px] flex-col items-end justify-end gap-0.5">
        <div
          class="flex items-center !gap-1"
          *ngIf="item?.price_per_distance || item?.original_price_per_distance"
        >
          <app-price-format
            class="mb-[-1px] font-inter text-sm font-normal text-palette-gray-400 line-through"
            *ngIf="item.original_price_per_distance > item.price_per_distance"
            [keepValue]="userCurrency === item.currency"
            [price]="
              userCurrency === item.currency
                ? item.original_price_per_distance_canal
                : item.original_price_per_distance
            "
          ></app-price-format>
          <app-price-format
            [keepValue]="userCurrency === item.currency"
            [price]="
              userCurrency === item.currency
                ? item.price_per_distance_canal
                : item.price_per_distance
            "
            [styleClass]="'text-xl font-medium text-palette-orange-dark-600'"
          ></app-price-format>
          <span class="overflow-hidden text-ellipsis text-md font-normal text-palette-gray-500"
            >/{{ 'COMMON.KM' | translate }}</span
          >
          <!-- <i class="sctr-icon-info-circle text-sm text-palette-gray-500"></i> -->
        </div>
        <div
          class="flex items-center !gap-1"
          *ngIf="item?.price_per_hour || item?.original_price_per_hour"
        >
          <app-price-format
            class="mb-[-1px] font-inter text-sm font-normal text-palette-gray-400 line-through"
            *ngIf="item.original_price_per_hour > item.price_per_hour"
            [keepValue]="userCurrency === item.currency"
            [price]="
              userCurrency === item.currency
                ? item.original_price_per_hour_canal
                : item.original_price_per_hour
            "
          ></app-price-format>
          <app-price-format
            [keepValue]="userCurrency === item.currency"
            [price]="
              userCurrency === item.currency ? item.price_per_hour_canal : item.price_per_hour
            "
            [styleClass]="'text-xl font-medium text-palette-orange-dark-600'"
          ></app-price-format>
          <span class="overflow-hidden text-ellipsis text-md font-normal text-palette-gray-500"
            >/{{ 'common.term.hour' | translate }}
          </span>
          <!-- <i class="sctr-icon-info-circle text-sm text-palette-gray-500"></i> -->
        </div>
      </div>
    </div>
  </div>
</div>
<app-toast keyToast="hd"></app-toast>
<app-dialog-save-list-car
  [visible]="visible"
  [detailId]="item.id"
  [key]="'hd'"
  (disable)="closeDialog()"
></app-dialog-save-list-car>
